import React, { useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from '../addCategoryForm/addCategoryForm.module.css';
import { Close, closeCircle, UploadImg } from '../../Svg';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddManufacturerForm = () => {

    const thumbnailImageref = useRef()
    const [loading, setLoading] = useState(false)
    const coverImageRef = useRef(null);
    const [isCoverUploadloading, setCoverUploading] = useState(false)
    const navigate = useNavigate()


    // Define the Formik schema
     const  {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({

        initialValues: {
            name: '',
            // description: '',
            cover_image: null,
            thumbnail: { photo: null, status: '' },
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Category name is required'),
            thumbnail: Yup.object().shape({
                status: Yup.string().required('Status is required'), 
            }),
            // description: Yup.string(),
        }),
        onSubmit: async (values) => {
            try {
                const { data, status } = await api.addManufacturer(values)
                if (status == 200) {
                    toast.success(data?.data?.message)
                    navigate(-1)
                }
            } catch (err) {
                console.log(err);
                toast.error(err?.response?.data?.message || 'something went wrong')
            }


        },
    });


    const handleImageChange = async (e, attribute, repo) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        if (repo == "photo") {
            setLoading(true)
        } else {
            setCoverUploading(true)
        }

        try {
            if (file) {
                const body = new FormData()
                body.append('image', file)
                body.append("repo", `category/${repo}`)

                const { data, status } = await api.fileUpload(body)

                if (status === 200) {
                    setFieldValue(attribute, data.data)
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {
            if (repo == "photo") {
                setLoading(false)
            } else {
                setCoverUploading(false)
            }
        }
    };


    const handleRemove = (repo) => {
        setFieldValue(repo, "")
    }



    return (
        <form onSubmit={handleSubmit} className={styles.updateCategoryContainer}>
            <div className={styles.genaralInfo}>
                <div className={styles.formSection}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>General Information</h2>
                        <label className={styles.addCatLabel}>
                            Manufacturer Name*
                            <input
                                type="text"
                                name="name"
                                placeholder="Type category name here..."
                                className={styles.addCatInput}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                            />
                            {touched.name && errors.name ? (
                                <div className={styles.errorText}>{errors.name}</div>
                            ) : null}
                        </label>
                        {/* <label className={styles.addCatLabel}>
                            Description
                            <textarea
                                name="description"
                                placeholder="Type category description here..."
                                className={styles.addCatTextarea}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.description}
                            ></textarea>
                        </label> */}


                        <div
                            className={styles.imageUpload}

                        >

                            <p className={styles.addCatLabel}>Cover Image</p>
                            {isCoverUploadloading ? <div className={styles.uploadBox}>Please wait...</div> :
                                <>

                                    {
                                        values.cover_image
                                            ? <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                                <img src={values.cover_image[0]} alt="" className={styles.previewImage} />
                                                <div className={styles.cancel_cross} onClick={() => handleRemove("cover_image")}>
                                                    {closeCircle()}
                                                </div>
                                            </div>
                                            :

                                            <div
                                                className={styles.uploadBox}
                                                onClick={() => coverImageRef.current.click()}
                                                onDrop={(e) => { e.preventDefault(); handleImageChange(e, "cover_image", "cover_image"); }}
                                                onDragOver={(e) => e.preventDefault()}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <span className={styles.uploadIcon}><UploadImg /></span>
                                                <p className={styles.addCatPara}>Drag and drop image here, or click to add image</p>
                                                <input
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                    ref={coverImageRef}
                                                    onChange={(e) => handleImageChange(e, "cover_image", "cover_image")}
                                                    accept="image/*"

                                                />
                                            </div>
                                    }
                                </>
                            }

                        </div>
                    </div>

                </div>
                <div className={styles.buttonGroup}>
                    <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                    <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "save"}</button>
                </div>
            </div>

            <div className={styles.thumbnain}>
                <div className={styles.card}>
                    <h2 className={styles.addCatH2}>Thumbnail</h2>
                    <p style={{ fontSize: '14px', color: '#777980', padding: '20px 0px 6px 0px' }}>Photo</p>

                    {loading ? <div className={styles.uploadBox}>please wait...</div> :
                        <>
                            {
                               values.thumbnail.photo
                                    ? <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <img src={values.thumbnail.photo[0]} alt="" className={styles.previewImage} />
                                        <div className={styles.cancel_cross} onClick={() => handleRemove("thumbnail.photo")}>
                                            {closeCircle()}
                                        </div>
                                    </div>
                                    :
                                    <div className={styles.uploadBox}
                                        onClick={() => thumbnailImageref.current.click()}
                                        onDrop={(e) => { e.preventDefault(); handleImageChange(e, 'thumbnail.photo', 'photo'); }}
                                        onDragOver={(e) => e.preventDefault()}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <span className={styles.uploadIcon}>
                                            <UploadImg />
                                        </span>
                                        <p className={styles.addCatPara}>Drag and drop image here, or click add image</p>
                                        <button type="button" className={styles.addImgBtn} >Add Image</button>
                                        <input type="file" name="" id=""
                                            ref={thumbnailImageref}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleImageChange(e, 'thumbnail.photo', 'photo')}
                                            accept="image/*"
                                        />

                                    </div>
                            }
                        </>
                    }



                    <div className={styles.card} style={{ marginTop: '20px' }}>
                        <h2 className={styles.addCatH2}>Status</h2>
                        <label className={styles.addCatLabel}>
                            Category Status*
                            <select
                                name="thumbnail.status"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.thumbnail.status}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.thumbnail?.status && errors.thumbnail?.status && (
                                <div className={styles.errorText}>{errors.thumbnail.status}</div>
                            )}
                        </label>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default AddManufacturerForm;
